import React from "react";
import styled, { css } from "styled-components";
var Tick = function Tick(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m7.167 10.512 6.128-6.129.943.943-7.071 7.071-4.243-4.243.943-.942 3.3 3.3Z",
    fill: "#18A318"
  }));
};
Tick.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import IconAtm from "../IconAtm";
import TextAtm from "../TextAtm";
var Container = styled(FlexContainerOrg).withConfig({
  componentId: "sc-1w8r48i-0"
})(function (_ref) {
  var $isCompleted = _ref.$isCompleted,
    $isActive = _ref.$isActive,
    $isNext = _ref.$isNext,
    theme = _ref.theme;
  return css(["border-radius:", ";height:", ";width:fit-content;padding:0 ", ";", " ", " ", "{padding:0 ", ";}"], getBorderRadius(theme, "large"), space(4), space($isNext ? 0.5 : 1), $isCompleted ? css(["background-color:", ";"], getColor(theme, "background")) : null, $isActive ? css(["background-color:", ";"], getColor(theme, "backgroundDarkLight")) : null, breakpoint("medium"), space($isNext ? 0.5 : 1.5));
});
var StepAtm = function StepAtm(_ref2) {
  var title = _ref2.title,
    state = _ref2.state;
  var isActive = state === "active";
  var isCompleted = state === "completed";
  var isNext = state === "next";
  return /*#__PURE__*/React.createElement(Container, {
    $isCompleted: isCompleted,
    $isActive: isActive,
    $isNext: isNext,
    gapSpace: 1,
    alignItems: "center"
  }, isCompleted ? /*#__PURE__*/React.createElement(IconAtm, {
    icon: Tick,
    sizeSpace: 2,
    color: "success"
  }) : null, /*#__PURE__*/React.createElement(TextAtm, {
    typography: isActive ? "tiny3" : "tiny1",
    emphasis: isActive ? "high" : "medium"
  }, title));
};
export default StepAtm;